export default __webpack_public_path__ + "static/media/account.775f36b5.svg";